import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort',
  pure: true
})
export class SortPipe implements PipeTransform {

  transform(list: any[], order: 'asc' | 'desc' = 'asc', arg: any = null): any {
    if (!list) {
      return list;
    }
    // console.log(list, order, arg);
    const val = order === 'asc' ? -1 : 1;
    switch (typeof arg) {
      case 'string': {
        const keys = arg.split('.');
        const getData = (obj) => keys.reduce((data, key) => data ? data[key] || null : null, obj);
        return [].concat(list).sort((a, b) => {
          // console.log(keys, getData(a), getData(b));
          return getData(a) < getData(b) ? val : -val;
        });
      }
      case 'function':
        return [].concat(list).sort(arg);
      default:
        return [].concat(list).sort((a, b) => a < b ? val : -val);
    }
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/pipes/sort.pipe.ts